import { Controller } from "@hotwired/stimulus"

// Keeps two numeric selects in order: the upper value must exceed the lower one
// by at least `gap`. Options that would break that are disabled rather than
// removed, so the full range stays visible, and the upper select moves forward
// if the lower one overtakes it.
//
// Usage:
//   <div data-controller="ordered-selects" data-ordered-selects-gap-value="1">
//     <select data-ordered-selects-target="lower"
//             data-action="change->ordered-selects#sync">…</select>
//     <select data-ordered-selects-target="upper"
//             data-action="change->ordered-selects#sync">…</select>
//   </div>
export default class extends Controller {
  static targets = ["lower", "upper"]
  static values = { gap: { type: Number, default: 1 } }

  connect() {
    this.sync()
  }

  sync() {
    const upperOptions = this.numericOptions(this.upperTarget)
    if (upperOptions.length === 0) return

    const lower = this.numericValue(this.lowerTarget)
    const ceiling = Math.max(...upperOptions.map((option) => Number(option.value)))

    this.numericOptions(this.lowerTarget).forEach((option) => {
      option.disabled = Number(option.value) + this.gapValue > ceiling
    })

    upperOptions.forEach((option) => {
      option.disabled = Number(option.value) < lower + this.gapValue
    })

    if (this.upperTarget.selectedOptions[0]?.disabled) {
      const next = upperOptions.find((option) => !option.disabled)
      if (next) this.upperTarget.value = next.value
    }
  }

  numericOptions(select) {
    return Array.from(select.options).filter((option) => Number.isFinite(Number(option.value)) && option.value !== "")
  }

  numericValue(select) {
    const value = Number(select.value)
    return Number.isFinite(value) ? value : 0
  }
}
